import { atom } from "recoil";

export const baseUpdatedFlagState = atom<boolean>({
  key: "baseUpdatedFlagState",
  default: false,
});
